import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

import { getCatalogStyles } from '../../../../store/category-page.selectors';
import { GridElement } from '../../models/grid.models';
import { CategoryGridService } from '../../services/category-grid.service';
import { LoadNextPageGridNewCollection, LoadNextPageStudioNewCollection } from '../../store/category-grid.actions';
import { getNewCollectionDefaultPageIdsFiltered, getNewCollectionStudioGridElementsFiltered, getNewCollectionStudioPageGridElements, getNewCollectionTitle } from '../../store/category-grid.selectors';

import { Category } from '@core/domain/models/category.models';
import { GridTypes } from '@shared/models/grid-type.model';
import { CategoryConfiguration, ProductViewConfig, ProductViewPlaceValue } from '@shared/product/models';

@Component({
    selector: 'app-grid-new-collection',
    templateUrl: './grid-new-collection.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridNewCollectionComponent implements OnInit {
    @Input() public category: Category;

    @Input() public isCategoryNew: boolean;

    @Input() public gridType: GridTypes;

    public templateConfiguration$: Observable<ProductViewConfig> = this.store.select(getCatalogStyles).pipe(
        map(catalogStyles =>
            CategoryGridService.mapTemplateConfig(catalogStyles, ProductViewPlaceValue.PRODUCT_NEW_COLLECTION)),
        shareReplay(1),
    );

    public defaultPageIdsFiltered$: Observable<number[]> = this.store.select(getNewCollectionDefaultPageIdsFiltered);

    public pageGridElements$: Observable<GridElement[]> = this.store.select(getNewCollectionStudioPageGridElements);

    public gridElementsFiltered$: Observable<GridElement[]> = this.store.select(getNewCollectionStudioGridElementsFiltered);

    public categoryConfiguration: CategoryConfiguration;

    public getNewCollectionTitle$: Observable<string> = this.store.select(getNewCollectionTitle);

    constructor(
        private readonly store: Store,
    ) {}

    public trackByIndex(index: number): number {
        return index;
    }

    public onScrollGridDefault(): void {
        this.store.dispatch(LoadNextPageGridNewCollection());
    }

    public onScrollGridStudio(): void {
        this.store.dispatch(LoadNextPageStudioNewCollection());
    }

    public ngOnInit(): void {
        this.categoryConfiguration = {
            soldOut: false,
            productConf: new Map(),
            category: this.category,
            isCategoryNew: this.isCategoryNew,
        };
    }
}
